import { useEffect, useState } from "react"
import { shortDate } from "../assets/functions.js";

export const CalendarInput = ({dateRef,showDate,label}) => {

    const [defaultDate, setDefaultDate] = useState();
    const [isoDate, setIsoDate] = useState('');

    useEffect(() => {
        let num = showDate ? 0 : 1;
        let oneDayAgo = new Date(new Date().setDate(new Date().getDate() - num));
        let currentDate = showDate ? shortDate(new Date().toISOString().split('T')[0]) : '';
        setDefaultDate(currentDate);
        setIsoDate(oneDayAgo.toISOString().split('T')[0])

    },[])
    
    const openCal = (e) => {
        let currentDate = e.target.parentElement.querySelector('input[type=date]')
        currentDate.showPicker();
    }
    
    const pickDate = (e) => {
        console.log("pick date---", e.target.value)
        let date = shortDate(e.target.value);

        setDefaultDate(date);
    }

    return (
        <div>
            {label && <label className="form-label">{label}</label>}
            <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="fa-solid fa-calendar"></i></span>
                <input type="date" aria-label={label || "Pick date"} className="form-control shadow-none position-absolute p-0 border-0" max={isoDate} style={{height:0}} onChange={pickDate}  />
                <input role="button" aria-label={label || "Selected date"} type="text" className="form-control shadow-none" defaultValue={defaultDate} ref={dateRef} onClick={openCal} readOnly />
            </div>
        </div>
    )
}